import { MessagingPlatform } from '@this+that/models';
import log from 'loglevel';

import { IntegrationAccount } from '../../../models/integrationAccount';

export interface ResolvedAccount {
  account: IntegrationAccount;
  accountId: string;
  platform: MessagingPlatform;
}

export const resolveEmailAccount = (
  fromEmail: string | undefined,
  currentIntegrationAccount: IntegrationAccount,
  integrationAccounts: IntegrationAccount[],
  options?: { strict?: boolean },
): ResolvedAccount | null => {
  if (fromEmail && fromEmail !== currentIntegrationAccount.displayName) {
    const selectedAccount = integrationAccounts.find(
      (account) => account.displayName === fromEmail,
    );
    if (selectedAccount) {
      return {
        account: selectedAccount,
        accountId: selectedAccount.displayName,
        platform: selectedAccount.platform as MessagingPlatform,
      };
    }
    log.warn(
      `[Draft] fromEmail "${fromEmail}" not found in integration accounts, falling back to current`,
      {
        fromEmail,
        availableAccounts: integrationAccounts.map((a) => a.displayName),
      },
    );
    if (options?.strict) {
      return null;
    }
  }

  return {
    account: currentIntegrationAccount,
    accountId: currentIntegrationAccount.displayName,
    platform: currentIntegrationAccount.platform as MessagingPlatform,
  };
};
